(function (algolia) {
  "use strict";
  if (!algolia.config.autocomplete_enabled) return;
  if(!algolia?.externals) return;
  const algoliasearch = algolia?.externals?.algoliasearch;
  const aa = algolia?.externals?.aa;
  let hoverCollection = null;
  let initialized = false;
  let redirect;

  function initializeAutocomplete() {
    if (initialized) {
      return;
    }

    initialized = true;

    document.querySelector("[data-autocomplete-container]").innerHTML =
      algolia.render(algolia.compileTemplate("autocomplete"), {
        storeName: algolia.storeName,
        with: {
          articles: algolia.config.index_articles,
          collections: algolia.config.index_collections,
          pages: algolia.config.index_pages,
          footer: algolia.config.instant_search_enabled,
          poweredBy: algolia.config.powered_by,
          products: algolia.config.index_products,
        },
      });

    const header = document.getElementById("shopify-section-header");
    document.querySelector(".predictive__search").style.top =
      header.clientHeight + "px";

    const searchClient = algoliasearch(
      algolia.config.app_id,
      algolia.config.search_api_key
    );
    const search = instantsearch({
      indexName: Theme.settings.algolia.product_index,
      searchClient: searchClient,
      searchFunction: function (searchFunctionHelper) {
        if (Boolean(algolia.config.show_products)) {
          searchFunctionHelper.setQueryParameter("distinct", true);
        }

        const context = [];

        if (
          !document.querySelector("[data-search-input]").value &&
          !hoverCollection
        ) {
          context.push("empty_search");
        }

        searchFunctionHelper.setQueryParameter("ruleContexts", context);

        if (hoverCollection) {
          searchFunctionHelper.setQueryParameter(
            "filters",
            `collections:"${hoverCollection}"`
          );
        } else {
          searchFunctionHelper.setQueryParameter("filters", "");
        }
        searchFunctionHelper.search();
      },
    });

    // Autocomplete widget to handle the search text input
    const textAutocomplete = instantsearch.connectors.connectAutocomplete(
      function (AutocompleteRenderingOptions, isFirstRendering) {
        const { refine, currentRefinement, indices } =
          AutocompleteRenderingOptions;
        const inputs = document.querySelectorAll("[data-search-input]");

        if (isFirstRendering) {
          [].forEach.call(inputs, function (input) {
            input.addEventListener(
              "input",
              debounce(function (e) {
                hoverCollection = null;
                refine(e.target.value);
              }, 100)
            );
          });

          const searchBars = document.querySelectorAll(".search-bar");
          [].forEach.call(searchBars, function (searchBar) {
            searchBar.addEventListener("submit", function (e) {
              if (redirect) {
                e.preventDefault();
                window.location = redirect;
                return;
              }
            });
          });
        }

        // Skip rendering if currentRefinement is coming from the collection hover and not the text input
        if (
          ![].some.call(inputs, function (input) {
            return input.value === currentRefinement;
          })
        ) {
          return;
        }

        const powerReviewsProducts = [];
        const productResults = indices.find(
          (item) => item.indexId === Theme.settings.algolia.product_index
        );
        const productsMarkup = buildAutocompleteProductCards(
          productResults,
          powerReviewsProducts,
          currentRefinement
        );

        redirect = productResults?.results.renderingContent?.redirect?.url;

        if (!hoverCollection) {
          const collectionResults = indices.find(
            (item) => item.indexId === Theme.settings.algolia.collection_index
          );
          const collectionsMarkup = buildAutocompleteCollectionsList(
            collectionResults,
            currentRefinement
          );

          document.querySelector(".dataset-collections").innerHTML =
            collectionsMarkup;
        }

        const footer = algolia.render(
          algolia.compileTemplate("autocomplete_footer"),
          {
            query: currentRefinement,
          }
        );

        document.querySelector(".dataset-products").innerHTML =
          productsMarkup + footer;

        // Wait for DOM to be ready otherwise the reviews won't load
        if (Theme.settings.reviews.enabled && powerReviewsProducts.length) {
          pwr("render", powerReviewsProducts);
        }
      }
    );

    search.addWidgets([
      instantsearch.widgets
        .index({ indexName: Theme.settings.algolia.product_index })
        .addWidgets([
          instantsearch.widgets.configure({
            hitsPerPage: algolia.config.products_autocomplete_hits_per_page,
          }),
        ]),
      instantsearch.widgets
        .index({ indexName: Theme.settings.algolia.collection_index })
        .addWidgets([
          instantsearch.widgets.configure({
            hitsPerPage: algolia.config.collections_autocomplete_hits_per_page,
          }),
        ]),
      textAutocomplete({ containerNode: $("[data-autocomplete-container]") }),
    ]);

    const isTouchDevice =
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0;

    // Second Autocomplete widget to handle just the hover effect
    const hoverAutocomplete = instantsearch.connectors.connectAutocomplete(
      function (AutocompleteRenderingOptions, isFirstRendering) {
        const { refine, currentRefinement, indices } =
          AutocompleteRenderingOptions;
        if (isFirstRendering) {
          if (isTouchDevice) {
            Theme.Global.dynamicBind(
              "touchend",
              "[data-autocomplete-collection]",
              function (e) {
                e.target.click();
              }
            );
          }

          Theme.Global.dynamicBind(
            "mouseover",
            "[data-autocomplete-collection]",
            function (e) {
              const hiddenNode = document.querySelector(
                "[data-autocomplete-hover-value]"
              );
              if (hiddenNode.value !== this.dataset.title) {
                hiddenNode.value = this.dataset.title;
                hoverCollection = this.dataset.handle;
                refine("");
              }
            }
          );

          // Reset the hover autocomplete whenever the search input is changed to prevent the hover autocomplete from overriding
          document
            .querySelector("[data-search-input]")
            .addEventListener("input", function (e) {
              hoverCollection = null;
            });
        }

        if (!indices.length) {
          return;
        }

        const powerReviewsProducts = [];
        const productsMarkup = buildAutocompleteProductCards(
          indices[0],
          powerReviewsProducts,
          currentRefinement
        );

        const footer = algolia.render(
          algolia.compileTemplate("autocomplete_footer"),
          {
            query: currentRefinement,
          }
        );

        AutocompleteRenderingOptions.widgetParams.containerNode.html(
          productsMarkup + footer
        );

        if (Theme.settings.reviews.enabled && powerReviewsProducts.length) {
          pwr("render", powerReviewsProducts);
        }
      }
    );

    search.addWidget(
      hoverAutocomplete({ containerNode: $(".aa-dataset-products") })
    );

    const analyticsTags = ["autocomplete"];

    const getDeviceType = () => {
      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
      }
      if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        return "mobile";
      }
      return "desktop";
    };

    analyticsTags.push(getDeviceType());

    // Algolia config
    search.addWidgets([
      instantsearch.widgets.configure({
        distinct: true,
        clickAnalytics: true,
        analyticsTags,
        hitsPerPage: algolia.config.products_autocomplete_hits_per_page,
      }),
    ]);

    search.start();
  }

  function setupRotateText() {
    const input = document.querySelector("[data-search-input]");
    const rotateText = document.querySelectorAll(".toggle-text");
    const handleKeyup = function () {
      if (this?.value) {
        [].forEach.call(rotateText, function (elm) {
          elm.classList.add("toggle-text--toggled");
          const span = elm.querySelector("span:last-child");
          elm.style.maxWidth = span.getBoundingClientRect().width + "px";
        });
      } else {
        [].forEach.call(rotateText, function (elm) {
          elm.classList.remove("toggle-text--toggled");
          const span = elm.querySelector("span:first-child");
          elm.style.maxWidth = span.getBoundingClientRect().width + "px";
        });
      }
    };

    input.addEventListener("keyup", handleKeyup);
    handleKeyup();
  }

  function sendProductClickedEvent() {
    const { objectId } = this.dataset;

    if (objectId) {
      const userToken = localStorage.getItem("algolia_user_token");

      if (userToken) {
        aa("clickedObjectIDs", {
          userToken: userToken,
          eventName: "Autocomplete: Product Clicked",
          index: window.Theme.settings.algolia.product_index,
          objectIDs: [objectId],
        });
      }
    }
  }

  function buildAutocompleteCollectionsList(collections, currentRefinement) {
    if (!collections || !collections.hits || !collections.hits.length) {
      return algolia.render(
        algolia.compileTemplate("autocomplete_collection_empty")
      );
    }

    return `<div class="aa-suggestions">${collections.hits
      .map((hit) => {
        return `<div  id="option-${
          hit.id
        }" class="aa-suggestion">${algolia.render(
          algolia.compileTemplate("autocomplete_collection"),
          {
            ...hit,
          }
        )}</div>`;
      })
      .join("")}</div>`;
  }

  function buildAutocompleteProductCards(products, powerReviewsProducts) {
    if (!products || !products.hits || !products.hits.length) {
      return algolia.render(
        algolia.compileTemplate("autocomplete_product_empty")
      );
    }

    return `<div class="grid-uniform">${products.hits
      .map((hit) => {
        powerReviewsProducts.push({
          ENABLE_CLIENT_SIDE_STRUCTURED_DATA: false,
          api_key: Theme.settings.reviews.api_key,
          locale: Theme.settings.reviews.locale,
          merchant_group_id: Theme.settings.reviews.group_id,
          merchant_id: Theme.settings.reviews.merchant_id,
          page_id: hit.id,
          components: {
            CategorySnippet: `autocomplete-snippet-${hit.id}`,
          },
        });

        return `<div id="option-${
          hit.id
        }" class="grid__item large--one-quarter medium--one-half small--one-half" role="option">${algolia.render(
          algolia.compileTemplate("autocomplete_product"),
          {
            ...hit,
          }
        )}</div>`;
      })
      .join("")}</div>`;
  }

  algolia.appendStyle(
    algolia.render(algolia.compileTemplate("autocomplete.css"), {
      colors: algolia.config.colors,
    })
  );

  document.addEventListener("DOMContentLoaded", () => {
    Theme.Global.dynamicBind(
      "click",
      "[data-product-link]",
      sendProductClickedEvent
    );
  });

  document.body.addEventListener("search-open", () => {
    initializeAutocomplete();
    setupRotateText();
  });
})(window.algoliaShopify);
